import React, { useEffect, useState } from "react";
import bem from 'utils/bem';
import toast from 'react-hot-toast';
import { Formik } from 'formik';
import validationSchema from './validationSchema';
import Form from './Form';
import CourseFormSuccess from 'forms/forms/CourseForm/CourseFormSuccess';
import Model from '../../../../model';
import './index.sass'
import { createDigital } from 'api/digitals';

const initialValues = {
    customerPhone: '',
    customerName: '',
    customerSurname: '',
    customerEmail: '',
    customerEmailConfirmation: '',
    paymentSystem: 'A',
    acceptConditions: false,
    mail: '',
    mailConfirmation: '',
    amount: '',
    gift: false,
    name: '',
    customerFound: false,
    saleSum: 0,
    sum: 0,
    paymentMethod: 'balance',
    price: 0
};

const { block, el } = bem('certificate-form');

const CourseForm = ({price, digitalId, title}) => {

    const [ submitSuccess, setSubmitSuccess ] = useState(false);

    useEffect(() => {
        if (!price) {
            toast.error(`К сожалению, покупка в данный момент недоступна. Пожалуйста, обратитесь к администратору`)
        }
    }, [price])

    const handleSubmit = async (values, bag) => {

        const variables = {
            ...values,
            digital: digitalId,
        };

        try {
            const { error, paymentStatus, payUrl } = await createDigital(variables);
            Model.user.updateUserInfo();
            if (error) {
                throw error;
            }
            if (paymentStatus === 'A_1' && !payUrl) {
                setSubmitSuccess(true);
                bag.resetForm();
                return;
            }
            if (payUrl) {
                window.location.href = payUrl;
            } else {
                throw 'payUrl is null';
            }
        } catch (err) {
            console.log(err);
            toast.error(`Произошла ошибка: ${ err }`);
            bag.setSubmitting(false);
        }
    };

    if (submitSuccess) {
        return <CourseFormSuccess />
    }

    return <div className={block()}>
        <Formik
            initialValues={initialValues}
            validateOnChange={false}
            validateOnBlur={false}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}>
            {props => <Form {...props} price={price} title={title}/>}
        </Formik>
    </div>
};

export default CourseForm;
